if (!customElements.get('hover-aniamtion-video')) {
  customElements.define(
    'hover-aniamtion-video',
    class HoverAnimationVideo extends HTMLElement {
      constructor() {
        super();
        this.desktopItems = [];
        this.mobileItems = [];
        this.mobileTabs = [];
        this.mode = null;
      }

      connectedCallback() {
        this.init();
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
      }

      handleResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.init(), 200);
      };

      init() {
        const isDesktop = window.innerWidth >= 768;

        if (this.mode === (isDesktop ? 'desktop' : 'mobile')) return;
        this.mode = isDesktop ? 'desktop' : 'mobile';

        this.cleanup();

        if (isDesktop) {
          this.initDesktop();
        } else {
          this.initMobile();
        }
      }

      cleanup() {
        [...this.querySelectorAll('video')].forEach(video => {
          video.pause();
        });
      }

      /* ================= DESKTOP ================= */

      initDesktop() {
        this.desktopItems = Array.from(
          this.querySelectorAll('.video-with-content')
        );

        if (!this.desktopItems.length) return;

        this.desktopItems.forEach((item, index) => {
          item.onmouseenter = () => this.setDesktopActive(index);
        });

        this.setDesktopActive(0);
      }

      setDesktopActive(index) {
        this.desktopItems.forEach((item, i) => {
          const video = item.querySelector('video');
          if (!video) return;

          this.prepareVideo(video);

          if (i === index) {
            item.classList.add('open');
            this.play(video);
          } else {
            item.classList.remove('open');
            video.pause();
          }
        });
      }

      /* ================= MOBILE ================= */

initMobile() {
  this.mobileItems = [...this.querySelectorAll('.video-with-content-mobile')];
  this.mobileTabs = [...this.querySelectorAll('.mobile-tab-video .video-preview-image')];

  console.log('mobile items', this.mobileItems);
  console.log('mobile tabs', this.mobileTabs);

  if (!this.mobileItems.length || !this.mobileTabs.length) return;

  this.mobileTabs.forEach((tab, index) => {
    tab.onclick = () => {
      console.log('TAB CLICK', index);
      this.setMobileActive(index);
    };
  });

  this.setMobileActive(0);
}

setMobileActive(index) {
  console.log('setMobileActive', index);

  this.mobileItems.forEach((item, i) => {
    const video = item.querySelector('video');

    if (i === index) {
      item.classList.add('active');
      this.mobileTabs[i].classList.add('active');
      console.log('ACTIVE ADDED', i);
    } else {
      item.classList.remove('active');
      this.mobileTabs[i].classList.remove('active');
    }

    if (video) video.pause();
  });
}

      /* ================= SHARED ================= */

      prepareVideo(video) {
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
      }

      play(video) {
        if (video.readyState >= 2) {
          video.play().catch(() => {});
        } else {
          video.addEventListener(
            'canplay',
            () => video.play().catch(() => {}),
            { once: true }
          );
        }
      }
    }
  );
}
